import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { ButtonLink } from 'next/components/ui';

import CoolTip from 'components/Common/CoolTip';
import DebouncedButton from 'components/Common/DebouncedButton';

const REFRESH_COOLDOWN_MS = 1000 * 60;

const TimestampContainer = styled.span`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

const UpdateButton = styled(ButtonLink)`
  margin-left: 8px;

  &[disabled] {
    color: var(--dirty-water);
    pointer-events: none;
  }
`;

const LinkWithTooltip = ({ disabled, ...rest }) => (
  <CoolTip
    position="top"
    disabled={!disabled}
    tip="Limited to once per minute."
  >
    <UpdateButton disabled={disabled} {...rest}>
      Update
    </UpdateButton>
  </CoolTip>
);

const TimestampRefresh = ({ endTime, onClick }) => {
  const dateString = moment(endTime).calendar().toLowerCase();
  return (
    <TimestampContainer>
      Last updated {dateString}
      <DebouncedButton
        onClick={onClick}
        waitMs={REFRESH_COOLDOWN_MS}
        as={LinkWithTooltip}
      />
    </TimestampContainer>
  );
};

export default TimestampRefresh;
